/**
 * @file index.tsx
 * @module app/modules/inter-transfer-request/index
 * @description Implements the index workflow for inter-transfer requests.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import InterTransferRequest from './inter-transfer-request';
import CreateInterTransferRequest from './create-inter-transfer-request';
import InterTransferDetail from './inter-transfer-detail';
import { PageLink, PageTitle } from '../../../_admin/layout/core';
const interTransferRequestBreadCrumbs: Array<PageLink> = [
  {
    title: 'Inter Transfer Request',
    path: '/inter-transfer-request',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];
const InterTransferRequestPage = () => (
  <Routes>
    <Route element={<Outlet />} />
    <Route
      index
      element={
        <>
          <PageTitle>
            Inter Transfer Request
          </PageTitle>
          <InterTransferRequest />
        </>
      }
    />
    <Route
      path="create-transfer-request"
      element={
        <>
          <PageTitle breadcrumbs={interTransferRequestBreadCrumbs}>
            Create Inter Transfer Request
          </PageTitle>
          <CreateInterTransferRequest />
        </>
      }
    />
    <Route
      path="inter-transfer-detail"
      element={
        <>
          <PageTitle breadcrumbs={interTransferRequestBreadCrumbs}>
            Inter Transfer Detail
          </PageTitle>
          <InterTransferDetail />
        </>
      }
    />
  </Routes>
);
export default InterTransferRequestPage;
